<template>
  <div :class="$style.footer">
    <div :class="$style.footerInner">
      <div class="mb-3">
        <a
          href="https://nursingexampro.com"
          target="_blank"
          rel="noopener noreferrer"
          :class="$style.logo"
        >
          NursingExamPro.com
        </a>
      </div>
      <p class="mb-0">
        Copyright © {{ this.currentYear }} NursingExamPro.com<br />
        <a
          href="https://nursingexampro.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy |
        </a>
        <a
          href="https://nursingexampro.com/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Use |
        </a>
        <a
          :href="`mailto:${supportEmail}`"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ supportEmail }}
        </a>
      </p>
    </div>
  </div>
</template>

<style lang="scss" module>
@import "./style.module.scss";
</style>

<script>
export default {
  data() {
    return {
      supportEmail: 'support@nursingexampro.com',
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
}
</script>
